// extracted by mini-css-extract-plugin
export var item__image = "ThreeImages-module--item__image--LL301";
export var paragraph = "ThreeImages-module--paragraph--pnEJC";
export var wrapper = "ThreeImages-module--wrapper--08ncm";